import { IcLookupPensionCompanyItemDto } from '@data-access/bulk-operations-api';

import { IcPensionCompany } from '../services/ic-pension-companies.service';
import { createIcServiceMock } from './item-cache-service.base.mock';

const icPensionCompanies: IcLookupPensionCompanyItemDto[] = [
  IcLookupPensionCompanyItemDto.fromJS({
    data: {
      name: 'Test Pension',
      organizationNumber: '817656935',
    },
    version: 1,
    id: 'id-pension-company-1',
  }),
  IcLookupPensionCompanyItemDto.fromJS({
    data: {
      name: 'Another Pension Company',
      organizationNumber: '937173539',
    },
    version: 1,
    id: 'id-pension-company-2',
  }),
];

// Should be synced with mapper in the service
function mapToLookupModel(value: IcLookupPensionCompanyItemDto): IcPensionCompany {
  return {
    ...value.data,
    id: value.id,
  };
}

export function getIcPensionCompaniesServiceMock() {
  return createIcServiceMock(icPensionCompanies.map(mapToLookupModel), icPensionCompanies);
}
